// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-width {
   width: 70%;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/contact/new-contact/new-contact.component.css"],"names":[],"mappings":"AAAA;GACG,UAAU;AACb;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":[".txt-width {\n   width: 70%;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
